export const getChampionshipId = championship => {
  switch (championship) {
    case 'FR':
      return 1;
    case 'GB-ENG':
      return 2;
    case 'ES':
      return 3;
    case 'FR2':
      return 4;
    case 'IT':
      return 5;
    case 'EU':
      return 6;
    case 'SUPER':
      return 7;
    default:
      return 1;
  }
};

export const getChampionshipName = championshipId => {
  switch (championshipId) {
    case 1:
      return 'FR';
    case 2:
      return 'GB-ENG';
    case 3:
      return 'ES';
    case 4:
      return 'FR2';
    case 5:
      return 'IT';
    case 6:
      return 'EU';
    case 7:
      return 'SUPER';
    default:
      return 'FR';
  }
};

export const champIds = {
  FR: 1,
  'GB-ENG': 2,
  ES: 3,
  FR2: 4,
  IT: 5,
  EU: 6,
  SUPER: 7,
};



// WEBPACK FOOTER //
// ./src/helpers/championship.js